/* Triumph Vlasim - zavirani naseptavace po odeslani hledani.
   Luigi's Box hleda in-place (bez reloadu), takze predictive-search sablony
   by jinak zustal viset pres vysledky. */
(function () {
  function zavri() {
    document.querySelectorAll('predictive-search').forEach(function (ps) {
      try { ps.close(); } catch (e) { ps.removeAttribute('open'); }
    });
    if (document.activeElement && document.activeElement.blur) {
      document.activeElement.blur();
    }
  }

  function navesit() {
    document.querySelectorAll('form[action*="/search"]').forEach(function (f) {
      if (f.dataset.tvcZavirani) return;
      f.dataset.tvcZavirani = '1';
      f.addEventListener('submit', function () { setTimeout(zavri, 0); }, true);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', navesit);
  } else {
    navesit();
  }
  // formulare se muzou dorenderovat pozdeji (mobilni menu apod.)
  new MutationObserver(navesit).observe(document.documentElement, {childList: true, subtree: true});
})();
